/* eslint-disable @typescript-eslint/indent */
import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import { RootState } from 'app/store';
import { signOutRequest } from 'features/auth/redux/auth-slice';
import { toast } from 'react-toastify';

const getBaseQueryWithLogout = (baseUrl: string) => {
  const baseQuery = fetchBaseQuery({
    baseUrl,
    prepareHeaders(headers, { getState }) {
      const state = getState() as RootState;

      if (state.user && state.user.accessToken) {
        headers.set('Authorization', `Bearer ${state.user.accessToken}`);
      }
      return headers;
    },
  });

  const baseQueryWithLogout: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
  > = async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);
    if (
      result.error &&
      result.error.status ===
        401 /* || result.error.status === 'PARSING_ERROR' */
    ) {
      toast('Your session expired!', {
        type: 'error',
        toastId: 'session-expired',
      });
      api.dispatch(signOutRequest());
    }
    return result;
  };

  return baseQueryWithLogout;
};

export default getBaseQueryWithLogout;
